import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpApiService } from '../http.api.service';

@Injectable({
  providedIn: 'root'
})
export class EfateCakeRunApiService extends HttpApiService {
  override apiUrl: string = environment.BAMS_Api_URL;

  startCAKE(efateSetupPk: number): Observable<any> {
    const endpoint = `api/efate/runCAKE/start/${efateSetupPk}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  getCAKEStatus(efateSetupPk: number, runId?: string): Observable<any> {
    const query = runId ? `?runId=${encodeURIComponent(runId)}` : '';
    const endpoint = `api/efate/runCAKE/status/${efateSetupPk}${query}`;
    return this.get(endpoint).pipe(map((data: any) => data?.Value ?? data));
  }

  getReportPreview(efateSetupPk: number, dataset: string, runId?: string): Observable<string> {
    return this.getText(this.reportEndpoint(efateSetupPk, dataset, runId));
  }

  downloadReport(efateSetupPk: number, dataset: string, runId?: string): Observable<Blob> {
    return this.getBlob(this.reportEndpoint(efateSetupPk, dataset, runId, true));
  }

  private reportEndpoint(efateSetupPk: number, dataset: string, runId?: string, download: boolean = false): string {
    const run = runId ? `&runId=${encodeURIComponent(runId)}` : '';
    return `api/efate/runCAKE/report/${efateSetupPk}?dataset=${encodeURIComponent(dataset)}${run}${download ? '&download=true' : ''}`;
  }
}
